import { render, staticRenderFns } from "./IconAccess.vue?vue&type=template&id=0b67962a&"
import script from "./IconAccess.vue?vue&type=script&lang=js&"
export * from "./IconAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b67962a')) {
      api.createRecord('0b67962a', component.options)
    } else {
      api.reload('0b67962a', component.options)
    }
    module.hot.accept("./IconAccess.vue?vue&type=template&id=0b67962a&", function () {
      api.rerender('0b67962a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconAccess.vue"
export default component.exports